import React from "react";
import MaskInput from "react-maskinput";

const MaskedInput = (props) => {
  return (
    <MaskInput
      {...props}
      disabled={props.disabled}
      alwaysShowMask
      maskChar={props.maskChar ? props.maskChar : ""}
      className={props.className}
      onChange={props.onChange}
      onFocus={props.onFocus}
    />
  );
};

export default MaskedInput;
